import Vuex from "vuex";
import axios from "axios";
import * as buffer from "buffer";
import router from "@/router";
window.Buffer = buffer.Buffer;
export default new Vuex.Store({
  state: {
    user: {
      username: localStorage.getItem("username"),
      isLoader: false,
      isAdmin: !!(localStorage.getItem("access_token") && localStorage.getItem("refresh")),
      loggedIn: false,
      token: localStorage.getItem("access_token") || "",
      refresh: localStorage.getItem("refresh"),
    },
  },
  getters: {
    auth(state) {
      const ref = localStorage.getItem("refresh");
      const token = localStorage.getItem("access_token");
      state.user.loggedIn = !!(ref && token);
      if (token) {
        state.user.token = token;
      }
      return state.user;
    },
    isAdmin() {
      return this.state.user.isAdmin;
    },
    isLoader() {
      return this.state.user.isLoader;
    },
    getUsername() {
      return this.state.user.username;
    },
  },
  actions: {
    RESET_ALL: (context) => {
      context.user.isAdmin = false;
      context.user.isLoader = false;
      context.user.loggedIn = false;
      context.user.token = "";
      context.user.refresh = "";
      context.user.username = "";
    },
    REFRESH_TOKEN: (context) => {
      return new Promise((resolve, reject) => {
        axios
          .post(import.meta.env.VITE_API_URL_REFRESH, null, {
            headers: { Authorization: `Bearer ${localStorage.getItem("refresh")}` },
          })
          .then((response) => {
            const accessToken = response.data.access_token;
            const refreshToken = response.data.refresh_token;
            localStorage.setItem("access_token", accessToken);
            if (refreshToken) {
              localStorage.setItem("refresh", refreshToken);
            }
            context.commit("SET_TOKEN", accessToken);
            context.commit("SET_ADMIN", true);
            context.commit("SET_LOGGED_IN", true);
            resolve(response);
            console.log(response, "then");
          })
          .catch((error) => {
            context.commit("SET_TOKEN", "");
            context.commit("SET_USERNAME", "");
            context.commit("SET_ADMIN", false);
            context.commit("SET_LOGGED_IN", false);
            context.commit("SET_IS_LOADER", false);
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh");
            localStorage.removeItem("username");
            router.push({ name: "login" });
            reject(error);
          });
      });
    },
    LOGIN: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(import.meta.env.VITE_API_URL_LOGIN, payload)
          .then((response) => {
            let username;
            if (response.data.data.email !== "") {
              username = response.data.data.email;
            } else {
              username = response.data.data.phone;
            }
            if (response.data.data.admin > 0) {
              localStorage.setItem("username", username);
              localStorage.setItem("access_token", response.data.access_token);
              localStorage.setItem("refresh", response.data.refresh_token);
              context.commit("SET_USERNAME", username);
              context.commit("SET_TOKEN", response.data.access_token);
              context.commit("SET_ADMIN", true);
              context.commit("SET_LOGGED_IN", true);
              context.commit(
                "SET_IS_LOADER",
                response.data.data.email === "dudnik.v@udtech.global"
              );
              if (
                import.meta.env.VITE_API_TYPE === "STAGE" ||
                import.meta.env.VITE_API_TYPE === "DEV"
              ) {
                console.log(response.data.data.email, "==>", response, ">-");
              }
            }
            resolve(response);
          })
          .catch((error) => {
            router.push({ name: "login" });
            reject(error);
          });
      });
    },
  },
  mutations: {
    SET_TOKEN: (state, payload) => {
      state.user.token = payload;
    },
    SET_USERNAME: (state, payload) => {
      state.user.username = payload;
    },
    SET_ADMIN: (state, payload) => {
      state.user.isAdmin = payload;
    },
    SET_LOGGED_IN: (state, payload) => {
      state.user.loggedIn = payload;
    },
    SET_IS_LOADER: (state, payload) => {
      state.user.isLoader = payload;
    },
  },
});
